var _excluded = ["children", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 *
 * A label for displaying error message.
 *
 * @name ErrorLabel
 * @type Function
 * @param {String} children - A message to display
 *
 * @example
 *
 * function MyView () {
 *   const [errorMessage, setErrorMessage] = useState()
 *   return (
 *      <div>
 *       <button onClick={ () => doSomething().catch(setErrorMessage) }>
 *          Do something
 *       </button>
 *      {
 *        errorMessage && <ErrorLabel>{ errorMessage }</ErrorLabel>
 *      }
 *     </div>
 *   )
 * }
 *
 */

var propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
var defaultProps = {
  className: ''
};
function ErrorLabel(_ref) {
  var children = _ref.children,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: classnames('error-message', className)
  }, rest), children);
}
ErrorLabel.propTypes = propTypes;
ErrorLabel.defaultProps = defaultProps;
export default ErrorLabel;